import {reduxProps} from '../../constants'
import React from 'react'
import {useSelector} from 'react-redux'
import {Button, Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import { actionDeleteModalClose } from "../../redux/modal";

export function DeleteModal() {
  const dispatch = useDispatch()

  const {deleteModalOpen, deleteModalField} = useSelector(
    (state: reduxProps) => state.modalReducer
  )

  const handleClose = () => {
    dispatch(actionDeleteModalClose())
  }

  const handlePress = () => {
    deleteModalField.deleteModalHandle()
    handleClose()
  }

  return (
    <Modal centered show={deleteModalOpen} onHide={handleClose} aria-labelledby='delete-modal-title' aria-describedby='delete-modal-description'>
      <div className={"delete-modal education-border-radius"}>
        <h3 id='delete-modal-title' className={"text-center title fs-1"}>{deleteModalField.title}</h3>
        <div id='delete-modal-description' className={"text-center content fs-2"}>{deleteModalField.content}</div>
        <div className={"action-area"}>
          <Button autoFocus variant='secondary' onClick={handleClose} className={"cancel fw-bold"}>
            Vazgeç
          </Button>
          <Button variant='danger' onClick={handlePress} className={"approve fw-bold"}>
            {deleteModalField.buttonText}
            <i className={"fa-regular fa-trash-can"}></i>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
